<script setup lang="ts">
const message = ref('')

const reloadPage = () => {
  if (typeof window !== 'undefined')
    window.location.reload()
}

const goToLogin = () => {
  useCookie('accessToken').value = null
  useCookie('userData').value = null
  useCookie('userAbilityRules').value = null

  try {
    localStorage.removeItem('activeAppId')
    localStorage.removeItem('tenantId')
  }
  catch {}

  if (typeof window !== 'undefined') {
    const loginPath = window.location.pathname.startsWith('/build/')
      ? '/build/login'
      : '/login'

    window.location.assign(loginPath)
  }
}

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

onMounted(async () => {
  try {
    const response = await $api('/public/platform/status')
    message.value = response?.maintenance_message || ''
  }
  catch {}
})
</script>

<template>
  <div class="misc-wrapper">
    <ErrorHeader
      status-code="503"
      :title="$t('maintenance_page_title')"
      :description="message || $t('maintenance_page_description')"
    />

    <div class="d-flex flex-wrap justify-center gap-4">
      <VBtn
        color="primary"
        @click="reloadPage"
      >
        {{ $t('maintenance_page_retry') }}
      </VBtn>

      <VBtn
        variant="outlined"
        @click="goToLogin"
      >
        {{ $t('auth.login') }}
      </VBtn>

      <VBtn
        variant="text"
        to="/"
      >
        {{ $t('maintenance_page_home') }}
      </VBtn>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core-scss/template/pages/misc.scss";
</style>
